import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Globals } from '../../../services/globals';

@Component({
  selector: 'app-table-delete-view',
  templateUrl: './table-delete-view.component.html',
  styleUrls: ['./table-delete-view.component.scss']
})
export class TableDeleteViewComponent implements OnInit {

  renderValue: string;
  eyeview='';
  assetsUrl = '';
  @Input() value: string | number;
  @Input() rowData: any;

  @Output() deleteClick: EventEmitter<any> = new EventEmitter();
  @Output() viewClick: EventEmitter<any> = new EventEmitter();

  constructor(public globals: Globals){}

  ngOnInit() {
    this.renderValue = this.value.toString();
    this.assetsUrl = this.globals.getAssetsUrl();    
    this.eyeview = this.assetsUrl + 'assets/images/view-icon.svg';
  }

  onDeleteClick() {
    this.deleteClick.emit(this.rowData);
  }

  onViewClick() {
    this.viewClick.emit(this.rowData);
  }
}
